module.exports = __webpack_public_path__ + "img/tier3-visual-f.adafa9c.svg";